module.exports = __webpack_public_path__ + "img/arrow-drop-down-fill@3x.8c5e0959.svg";